















































import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import { endpoints } from "@/endpoints";
import { formatForMetric } from "./formatters";
import { shortHelpForMetric, labelForMetric } from "./catalogHelpers";
import { applyFilterParams, RcaFilters } from "./filterQueryParams";
import RcaEndpointData from "./data-mixin";

interface KpiSpec {
    /** Name of the column this card's number is read from. */
    key: string;
    /** Catalog metric id — the source of both the card label and the ?-tooltip. */
    helpId: string;
}

const KPI_SPECS: KpiSpec[] = [
    {
        key: "closure_event_count",
        helpId: "overview_closure_event_count_sum",
    },
    {
        key: "impacted_trip_count_sum",
        helpId: "overview_impacted_trip_count_sum",
    },
    {
        // Endpoint-exposure grain (trip_endpoint_exposure): an enterprise is counted when it
        // sits at the origin/destination of at least one impacted trip.
        key: "endpoint_impacted_enterprise_count_sum",
        helpId: "overview_endpoint_impacted_enterprise_day_count_sum",
    },
    {
        key: "endpoint_rerouted_enterprise_count_sum",
        helpId: "overview_endpoint_rerouted_enterprise_day_count_sum",
    },
    {
        key: "endpoint_blocked_enterprise_count_sum",
        helpId: "overview_endpoint_blocked_enterprise_day_count_sum",
    },
    {
        key: "road_delta_time_hours_sum",
        helpId: "overview_road_delta_time_hours_sum",
    },
    {
        key: "road_delta_length_km_sum",
        helpId: "overview_road_delta_length_km_sum",
    },
];

@Component
export default class KpiCards extends mixins(RcaEndpointData) {
    @Prop({ required: true }) startDate!: string;
    @Prop({ required: true }) endDate!: string;
    /** Metric catalog payload — fetched at the dashboard root and passed in. */
    @Prop({ default: null }) catalog!: any;
    /** Global sidebar filters — narrow the rollup to matching trips. */
    @Prop({ default: () => ({}) }) filters!: RcaFilters;

    helpFor(metricId: string): string {
        return shortHelpForMetric(this.catalog, metricId);
    }

    mounted() {
        this.fetch();
    }

    /** One key over every fetch input so a param change triggers exactly one fetch. */
    private get fetchParamsKey(): string {
        return `${this.startDate}|${this.endDate}|${JSON.stringify(
            this.filters,
        )}`;
    }

    @Watch("fetchParamsKey")
    onRangeChanged() {
        this.fetch();
    }

    fetch() {
        if (!this.startDate || !this.endDate) return;
        this.loadData(
            endpoints.roadClosureAnalyticsSummaryRollupUrl,
            applyFilterParams(
                { start_date: this.startDate, end_date: this.endDate },
                this.filters,
            ),
        );
    }

    get row() {
        return Array.isArray(this.data) && this.data.length > 0
            ? this.data[0]
            : null;
    }

    get kpis() {
        if (!this.row) return [];
        return KPI_SPECS.map((spec) => ({
            ...spec,
            label: labelForMetric(this.catalog, spec.helpId),
            value: formatForMetric(spec.key)(this.row[spec.key]),
        }));
    }

    /** Number of KPI stubs to show while loading — matches the real metric count. */
    get kpiCount(): number {
        return KPI_SPECS.length;
    }
}
